import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from './api';
import authReducer from './authSlice';
import currencyReducer from './currencySlice';
import languageReducer from './languageSlice';
import homeSearchReducer from './homeSearchSlice';
import comparisonReducer from './comparisonSlice';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    currency: currencyReducer,
    language: languageReducer,
    homeSearch: homeSearchReducer,
    comparison: comparisonReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);
